import { resolveCssVariable } from '@/utils/Common.utils';

import type { DonutChartDataTypes } from './DonutChart.types';

const getDonutColors = (
  dataArr: DonutChartDataTypes[],
  resolveHexValues: boolean = false
) => {
  const colorsArr: string[] = [];
  const defaultColors = [
    'var(--mui-palette-chartColors-0)',
    'var(--mui-palette-chartColors-1)',
    'var(--mui-palette-chartColors-2)',
    'var(--mui-palette-chartColors-3)',
    'var(--mui-palette-chartColors-4)',
    'var(--mui-palette-chartColors-5)',
    'var(--mui-palette-chartColors-6)',
    'var(--mui-palette-chartColors-7)',
    'var(--mui-palette-chartColors-8)',
    'var(--mui-palette-chartColors-9)'
  ];

  for (let i = 0; dataArr.length > i; i += 1) {
    const color = dataArr[i].color || defaultColors[i % defaultColors.length];
    if (resolveHexValues && dataArr[i].color) {
      colorsArr.push(resolveCssVariable(color) ?? color);
    } else {
      colorsArr.push(color);
    }
  }
  return colorsArr;
};

const donutToolTipRenderer = (params: {
  datum: { name: string; count: number };
  fill?: string;
}) => {
  const { datum, fill } = params;
  return `
      <div style="
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        padding: 8px 12px;
        min-width: 120px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;
      ">
        <span style="
          width: 12px;
          height: 12px;
          background: ${fill ?? 'transparent'};
          display: inline-block;
          margin-right: 10px;
          border-radius: 2px;
          border: 1px solid #ccc;
        "></span>
        <span style="flex: 1; font-weight: 500;">${datum.name}</span>
        <span style="margin-left: 12px; font-variant-numeric: tabular-nums; font-weight: 600;"">${datum.count}</span>
      </div>
    `;
};

export { donutToolTipRenderer, getDonutColors };
